import React from 'react'
import i18n from 'i18next'

import Typography from '../../../UniformComponents/Typography'

const Specification = () => (
    <div className="pp-summary-slide-container">
        <div className="pp-summary-slide-header">
            <div className="pp-summary-slide-header-text-container">
                <Typography type="tiny" color="primary">{i18n.t('s_tab_overview')}</Typography>

                <Typography color="white">Project specifications - SURVEY NAME</Typography>
            </div>

            <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ height: 30 }} />
        </div>

        <div className="pp-summary-slide-content">
            <div className="pp-summary-slide-content-column">
                <div>
                    <ul>
                        <li>
                            <Typography>Event date:</Typography>
                        </li>

                        <li>
                            <Typography>Fieldwork dates</Typography>
                        </li>
                    </ul>

                </div>

                <div>
                    <ul>
                        <li>
                            <Typography>{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                        </li>

                        <li>
                            <Typography>{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="pp-summary-slide-content-column">
                <div>
                    <Typography type="b" color="white">Attendees</Typography>

                    <ul>
                        <li>
                            <Typography>XXX contacts sent survey</Typography>
                        </li>

                        <li>
                            <Typography>Two reminder emails</Typography>
                        </li>

                        <li>
                            <Typography>Incentivised with 5x $100 Amazon gift cards</Typography>
                        </li>

                        <li>
                            <Typography>758 completes - 6.9% response rate</Typography>
                        </li>
                    </ul>
                </div>

                <div>
                    <Typography type="b" color="white">Exhibitors</Typography>

                    <ul>
                        <li>
                            <Typography>XXX contacts sent survey</Typography>
                        </li>

                        <li>
                            <Typography>Two reminder emails</Typography>
                        </li>

                        <li>
                            <Typography>Incentivised with 5x $100 Amazon gift cards</Typography>
                        </li>

                        <li>
                            <Typography>758 completes - 6.9% response rate</Typography>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
)

export default Specification
